<script>
  export default {
    name: 'PageFormItem',
    props: {
      title: {
        type: String,
        default: '',
        required: true,
      },
    },
  };
</script>

<template>
  <div>
    <header class="header">
      <h1>{{ title }}</h1>
      <div>
        <slot name="header-actions" />
      </div>
    </header>
    <main>
      <slot name="content" />
    </main>
  </div>
</template>

<style scoped lang="scss">
  .header {
    display: flex;
    gap: 20px;
  }
</style>
